import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonCircle = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		opacity: .3,
		d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12 6C15.6534 6 15.8818 9.55512 15.8818 11.333C15.8818 12.3481 15.1374 13.3634 14.498 14.0479C14.0825 14.4923 14.1244 15.2302 14.6387 15.5635L16.6309 16.8564C16.9678 17.0751 17.2513 17.3634 17.46 17.7012C17.6685 18.0389 17.7976 18.4175 17.8379 18.8096L17.9619 20.0283C16.2971 21.2667 14.2343 22 12 22C9.76518 22 7.70212 21.2662 6.03711 20.0273L6.16211 18.8096C6.20226 18.4176 6.33167 18.0389 6.54004 17.7012C6.74844 17.3635 7.03153 17.0751 7.36816 16.8564L9.3623 15.5635C9.87627 15.2292 9.91747 14.4931 9.50195 14.0479C8.86259 13.3634 8.11816 12.3481 8.11816 11.333C8.11819 9.55514 8.34671 6.00006 12 6Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgPersonCircle);
export { ForwardRef as ReactComponent };
